import { useCallback, useState } from "react";

export const ALLOWED_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "docm",
  "dotx",
  "rtf",
  "txt",
  "xls",
  "xlsx",
  "xlsm",
  "pot",
  "potm",
  "potx",
  "pps",
  "ppsm",
  "pptx",
  "ppt",
  "pptm",
];

export const MB_FILE_SIZE = 6;

const MAX_FILE_SIZE = MB_FILE_SIZE * 1024 * 1024;

const getFileExtension = (fileName) => {
  return fileName.split(".").pop()?.toLowerCase() || "";
};

export const useFileValidation = () => {
  const [validationState, setValidationState] = useState({
    isFileInvalid: false,
    isFileTooLarge: false,
  });

  const validateFile = useCallback((file) => {
    const nextState = {
      isFileInvalid: false,
      isFileTooLarge: false,
    };

    if (!ALLOWED_EXTENSIONS.includes(getFileExtension(file.name))) {
      nextState.isFileInvalid = true;
    }

    if (file.size > MAX_FILE_SIZE) {
      nextState.isFileTooLarge = true;
    }

    setValidationState(nextState);

    return !nextState.isFileInvalid && !nextState.isFileTooLarge;
  }, []);

  const clearValidation = useCallback(() => {
    setValidationState({
      isFileInvalid: false,
      isFileTooLarge: false,
    });
  }, []);

  return {
    ...validationState,
    validateFile,
    clearValidation,
  };
};
